import React from "react";
import SuperAdminRBAC from "../superadmin/RBAC";

/**
 * Institute/Admin RBAC (scoped by backend to current institute via JWT).
 * Reuses the Super Admin RBAC UI for consistent UX.
 */
export default function AdminRBAC() {
  return <SuperAdminRBAC />;
}